/* eslint-disable max-len */
import React from 'react';

interface ExlamationCircleProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const ExchangeAlt: React.FC<ExlamationCircleProps> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6643 1.20277C13.9347 0.932409 14.373 0.932409 14.6434 1.20277L18.7972 5.35662C18.9271 5.48645 19 5.66254 19 5.84615C19 6.02977 18.9271 6.20586 18.7972 6.33569L14.6434 10.4895C14.373 10.7599 13.9347 10.7599 13.6643 10.4895C13.3939 10.2192 13.3939 9.78083 13.6643 9.51046L16.6363 6.53846L5.84615 6.53846C5.4638 6.53846 5.15385 6.2285 5.15385 5.84615C5.15385 5.4638 5.4638 5.15385 5.84615 5.15385L16.6363 5.15385L13.6643 2.18184C13.3939 1.91148 13.3939 1.47314 13.6643 1.20277ZM6.33569 9.51046C6.60605 9.78083 6.60605 10.2192 6.33569 10.4895L3.36369 13.4615H14.1538C14.5362 13.4615 14.8462 13.7715 14.8462 14.1538C14.8462 14.5362 14.5362 14.8462 14.1538 14.8462H3.36369L6.33569 17.8182C6.60605 18.0885 6.60605 18.5269 6.33569 18.7972C6.06533 19.0676 5.62698 19.0676 5.35662 18.7972L1.20277 14.6434C0.932409 14.373 0.932409 13.9347 1.20277 13.6643L5.35662 9.51046C5.62698 9.2401 6.06533 9.2401 6.33569 9.51046Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default ExchangeAlt;
